import { getAiproxyRowEnabledActions } from '@Ai/utils/aiproxyEnabledActions'

export default {
  created () {
    this.singleActions = [
      {
        label: this.$t('common.more'),
        actions: obj => [
          {
            label: this.$t('common.edit'),
            permission: 'ai_proxy_nodes_update',
            action: () => {
              this.createDialog('AiProxyNodeFormDialog', {
                type: 'edit',
                data: [obj],
                columns: this.columns,
                onManager: this.onManager,
                refresh: this.refresh,
              })
            },
          },
          ...getAiproxyRowEnabledActions(this, obj, 'ai_proxy_nodes', this.$t('aice.aiproxy.proxy_node')),
          {
            label: this.$t('table.action.delete'),
            permission: 'ai_proxy_nodes_delete',
            action: () => {
              this.createDialog('DeleteResDialog', {
                vm: this,
                data: [obj],
                columns: this.columns,
                title: this.$t('table.action.delete'),
                name: this.$t('aice.aiproxy.proxy_node'),
                onManager: this.onManager,
              })
            },
            meta: () => {
              if (obj.id === 'primary') {
                return { validate: false, tooltip: this.$t('aice.aiproxy.primary_node_undeletable') }
              }
              return this.$getDeleteResult(obj)
            },
          },
        ],
      },
    ]
  },
}
